
import { required } from 'vuelidate/lib/validators'

export default {
  address: {
    label: {
      required
    },
    zip: {
      required
    },
    street: {
      required
    },
    city: {
      required
    },
    district: {
      required
    },
    number: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/resources/validations.js